module.exports = __webpack_public_path__ + "static/media/baltic_sea.46df4ac0.png";